import "./navbar.css";
import { NavLink } from "react-router-dom";
import Select, { type SelectItem } from "../select/Select";


interface NavbarProps {
    onClick?: () => void;
    displayName?: string;
    navbarItems?: {label: string, link: string}[]
    options?: SelectItem[];
 }

export default function NavBar({displayName, options, navbarItems, ...props}: NavbarProps) {

    return (
        <header className="navbar">
            <div className="navbar-logo">
                <div className="navbar-logo-icon">
                    P
                </div>
                <div className="navbar-logo-text">
                    <span>Patrimoine</span>
                    <small>Management</small>
                </div>
            </div>
            {navbarItems && 
            <nav className="navbar-links">
                {navbarItems.map((navbarItem) => 
                <NavLink key={navbarItem.label} to={navbarItem.link}>{navbarItem.label}</NavLink>)}
            </nav>}
            <div className="navbar-actions">
                {displayName && <Select label={displayName} items={options}/>}
            </div>
        </header>
    );

}